var map = {
	"./KAB-token.png": 286,
	"./OKG-token.png": 167,
	"./divider.png": 742,
	"./icon-bybit-button.png": 575,
	"./icon-checkbox-no.png": 372,
	"./icon-checkbox-yes.png": 373,
	"./icon-cocoon.png": 1056,
	"./icon-double-heart-left.png": 785,
	"./icon-double-heart-right.png": 750,
	"./icon-email-success.png": 563,
	"./icon-filter.png": 786,
	"./icon-get-KAB.png": 1057,
	"./icon-get-OKG.png": 1058,
	"./icon-hero.png": 1059,
	"./icon-logout.png": 576,
	"./icon-mana-deactive.png": 577,
	"./icon-mana.png": 578,
	"./icon-pancakeswap-button.png": 579,
	"./icon-power.png": 545,
	"./icon-radio-button-checked.png": 787,
	"./icon-radio-button.png": 788,
	"./icon-success.png": 128,
	"./icon-warning.png": 580,
	"./round-rock-icon.png": 1060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 371;